import { EmptyStateOnboarding, EmptyStateTenantsIllustration } from "@octopusdeploy/design-system-components";
import * as React from "react";
import ExternalLink from "~/components/Navigation/ExternalLink/ExternalLink";
import { AddTenant } from "./AddOrCloneTenant";
const Onboarding = () => (<EmptyStateOnboarding title="Tenants" description="Use Tenants to deploy your projects to multiple end-customers, with the software tailored to each specific customer." learnMore={<ExternalLink href="MultiTenantDeployments">Learn more</ExternalLink>} primaryAction={{
        type: "custom",
        content: <AddTenant />,
        key: "add-tenant",
    }} image={<EmptyStateTenantsIllustration />}/>);
export default Onboarding;
